import { Link, Navigate, useLocation } from "react-router-dom";
import { useOrganizationStore } from "../../../store/organization.store";
import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import {
    Box,
    Button,
    Divider,
    Paper,
    Rating,
    Typography,
    useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import { FeedbacksReasons } from "../../../configs/feedbacks-reasons.config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Loading } from "../../../utils/components/Loading";
import { FeedBack } from "../../../types/Store/OrganizationStore.types";
import { useTicketsStore } from "../../../store/tickets.store";
import { Ticket } from "../../../types/Store/TicketsStore.types";
import "react-photo-view/dist/react-photo-view.css";
import { PhotoProvider, PhotoView } from "react-photo-view";

export function TicketDetailed() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isMobile = useMediaQuery("(max-width:1100px)");

    const id = searchParams.get("id");
    if (!id) return <Navigate to={"/"} />;

    const { getTicketById, sendRating } = useTicketsStore();
    const [pageLoading, setPageLoading] = useState(true);
    const [candidate, setCandidate] = useState<Ticket | null>(null);
    useLayoutEffect(() => {
        (async () => {
            try {
                setPageLoading(true);
                const cand = await getTicketById(id);
                if (cand) {
                    setCandidate(cand);
                }
            } catch (error) {
            } finally {
                setPageLoading(false);
            }
        })();
    }, []);

    if (pageLoading)
        return (
            <Box
                sx={{
                    width: "90%",
                    height: "200px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Loading />
            </Box>
        );

    if (!candidate) return <Navigate to={"/admin/tickets"} />;

    return (
        <Box>
            <Button
                sx={{ marginBottom: "16px" }}
                component={Link}
                to="/admin/tickets"
                variant="contained"
            >
                Назад
            </Button>
            <Paper
                sx={{
                    padding: "24px",
                }}
            >
                <Box>
                    <h1>Заявление: {candidate.title}</h1>
                    <Typography color="#777">
                        {dayjs(candidate.created_at).format(
                            "от DD MMM YYYY г.",
                        )}
                    </Typography>
                    <Typography color="#777">
                        {FeedbacksReasons[candidate.reason]}
                    </Typography>
                    <h3>Описание:</h3>
                    <Typography>{candidate.description}</Typography>
                    <Box
                        sx={{
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                        }}
                    >
                        <PhotoProvider>
                            {candidate.photos.map((n) => {
                                return (
                                    <PhotoView src={n.url} key={n.id}>
                                        <img
                                            src={n.url}
                                            style={{
                                                width: "200px",
                                                height: "200px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </PhotoView>
                                );
                            })}
                        </PhotoProvider>
                    </Box>
                </Box>
            </Paper>
            <Divider
                sx={{
                    marginTop: "16px",
                    marginBottom: "16px",
                }}
            />
            {candidate.answers.length > 0 ? (
                <Paper
                    sx={{
                        padding: "24px",
                    }}
                >
                    {candidate.answers.map((n) => {
                        return (
                            <Box key={n.id}>
                                <h2>
                                    Ответ{" "}
                                    {dayjs(n.created_at).format(
                                        "от DD MMM YYYYг.",
                                    )}
                                </h2>
                                <Typography sx={{ whiteSpace: "pre-wrap" }}>
                                    {n.text}
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: "8px",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <PhotoProvider>
                                        {n.photos.map((n) => {
                                            return (
                                                <PhotoView
                                                    src={n.url}
                                                    key={n.id}
                                                >
                                                    <img
                                                        src={n.url}
                                                        style={{
                                                            width: "200px",
                                                            height: "200px",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </PhotoView>
                                            );
                                        })}
                                    </PhotoProvider>
                                </Box>
                            </Box>
                        );
                    })}
                </Paper>
            ) : (
                <Paper
                    sx={{
                        padding: "24px",
                    }}
                >
                    <Typography>Здесь пока нет ответов</Typography>
                </Paper>
            )}
            {candidate.status == "COMPLETED" && (
                <Paper
                    sx={{
                        marginTop: "20px",
                        padding: "24px",
                    }}
                >
                    <h2>Оцените обращение</h2>
                    <Rating
                        size={"large"}
                        defaultValue={candidate.rating}
                        readOnly={candidate.rating > 0}
                        onChange={(e, value) => {
                            sendRating(candidate.id, value || 0);
                            setCandidate((prev: any) => {
                                return {
                                    ...prev,
                                    rating: value || 0,
                                };
                            })
                        }}
                    />
                </Paper>
            )}
        </Box>
    );
}
